import { redirect } from "react-router";

/**
 * `/` renders the Home hero (see home-page.tsx). This loader only resolves old
 * `?feature=shipments|orders` bookmarks (the single-page app's only routing signal
 * before this rewrite) onto the equivalent real route, preserving every other
 * search param. Without a `?feature=` param it returns null, so Home renders.
 */
export function loader({ request }: { request: Request }) {
  const url = new URL(request.url);
  const feature = url.searchParams.get("feature");
  if (feature === null) return null;
  url.searchParams.delete("feature");
  url.pathname = feature === "orders" ? "/orders" : "/shipments";
  return redirect(url.pathname + url.search);
}
